import { Drawer } from '@mui/material';

// Form
import { SetupRubberDuckRoundDrawerContent } from './SetupRubberDuckRoundDrawerContent';

// Redux
import { useDispatch } from 'react-redux';
import { useRubberDuckRoundDrawer } from '@Modal/hooks/rounds/useRubberDuckRoundDrawer';

export const SetupRubberDuckRoundDrawer: React.FC = () => {
  const { showRoundDrawer, setShowRoundDrawer } = useRubberDuckRoundDrawer();
  const dispatch = useDispatch();

  return (
    <Drawer
      anchor="right"
      open={showRoundDrawer}
      onClose={() => dispatch(setShowRoundDrawer(false))}
    >
      <SetupRubberDuckRoundDrawerContent />
    </Drawer>
  );
};
